import classNames from 'classnames';

import PillButton, { PillButtonProps } from '../buttons/PillButton';
import Menu, { MenuProps } from './Menu';

import styles from '../../styles/menus/pills-menu.module.css';

interface PillsMenuProps extends MenuProps, PillButtonProps {}

const PillsMenu = ({
    buttonComponent = PillButton,
    className = null,
    itemsClassName = null,
    itemClassName = null,
    buttonClassName = null,
    ...props
}: PillsMenuProps) => {
    return (
        <Menu
            compact
            buttonComponent={buttonComponent}
            className={classNames([styles.container, className || undefined])}
            itemsClassName={classNames([styles.items, itemsClassName || undefined])}
            itemClassName={classNames([styles.item, itemClassName || undefined])}
            buttonClassName={classNames([styles.button, buttonClassName || undefined])}
            {...props}
        />
    );
};

export default PillsMenu;
